import { usePolicyPageData } from 'src/app/pages/legal/policy/pageContext';

type Result = ModelHookResult<{
	html: string;
	styles: string;
}>;

export function usePageBody(): Result {
	const {
		data: { content, css },
	} = usePolicyPageData();

	return {
		data: { html: content, styles: css },
	};
}
